export default "https://cdn-static-staging.gokick.com/assets/8be3c2df1b703b0455f7e6e91c436c85253a82ea/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";